import React from 'react'
import './Inputs.css'

const Input = ({type="text", value, name, onBlur, onChange, placeholder, icon=null, btn=false}) => { //btn - для pass recover ""
  
  return (
    <div className="input-wrapper">
        <input name={name} onBlur={onBlur} value={value} onChange={onChange} type={type} placeholder={placeholder} className={icon ? "inputSVG" : ""}/>
        {
          icon?  
          <div className={btn ? "icon-block  icon-block-btn" : "icon-block"}>
            {icon}
          </div>
          :
          ""      
        }
    </div>
  )
}

export default Input